import { Box } from '@mui/material'
import { FC, Fragment } from 'react'

import type { EventMarker } from '@/data/source'

import { EventMarkerIcon } from '../atoms/EventMarkerIcon'
import { FlowArrow } from '../atoms/FlowArrow'
import { useMarkerLabel } from './useMarkerLabel'

export const ScaleEventMarkers: FC<{ markers: EventMarker[] }> = ({ markers }) => {
  const label = useMarkerLabel()
  return (
    <Box display="flex" flexWrap="wrap" alignItems="center" gap={0.5} data-testid="event-markers">
      {markers.map((marker, index) => (
        <Fragment key={marker.id}>
          {index > 0 && <FlowArrow />}
          <EventMarkerIcon marker={marker} label={label(marker)} />
        </Fragment>
      ))}
    </Box>
  )
}
